module.exports = __webpack_public_path__ + "static/CRS_04_new-ead76d55d85add3b60b6ca1a5eef316c.svg";